import { useMutation } from '@tanstack/react-query';
import mutationFnFactory from './debt-cancellation-put-query';
export function useDebtCancellationPutQuery({ config, mutationOptions = {} }) {
    return useMutation({
        mutationFn: payload => new Promise((resolve, reject) => {
            const mutationFn = mutationFnFactory(config, payload);
            mutationFn(payload).then(resolve).catch(reject);
        }),
        ...mutationOptions
    });
}
